/**
 * Library difficulty order: expert/advanced first, then intermediate, then basics.
 * Matches backend search ordering when a notebook or topic filter is active.
 */
const LEVEL_RANK = {
  expert: 0,
  experts: 0,
  advanced: 0,
  intermediate: 1,
  basics: 2,
  basic: 2,
};

export function levelSortRank(subCategory1) {
  const key = String(subCategory1 || '').trim().toLowerCase();
  if (Object.prototype.hasOwnProperty.call(LEVEL_RANK, key)) {
    return LEVEL_RANK[key];
  }
  return 50;
}

export function sortQuestionsByLevel(items) {
  if (!Array.isArray(items) || items.length < 2) return items;
  return [...items].sort((a, b) => {
    const rankDiff = levelSortRank(a.subCategory1) - levelSortRank(b.subCategory1);
    if (rankDiff !== 0) return rankDiff;
    return (b.id ?? 0) - (a.id ?? 0);
  });
}

export function shouldSortLibraryByLevel(selectedNoteBook, selectedTopic) {
  return Boolean(selectedNoteBook?.length || selectedTopic?.length);
}

/** Fisher–Yates shuffle (new array). */
export function shuffleQuestions(items) {
  if (!Array.isArray(items) || items.length < 2) return items;
  const out = [...items];
  for (let i = out.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}

/** Order library page results: level sort when filtered by notebook/topic, else random. */
export function orderLibraryQuestions(items, selectedNoteBook, selectedTopic) {
  if (!Array.isArray(items) || items.length === 0) return items;
  if (shouldSortLibraryByLevel(selectedNoteBook, selectedTopic)) {
    return sortQuestionsByLevel(items);
  }
  return shuffleQuestions(items);
}
